import { render, staticRenderFns } from "./FolderListSidebar.vue?vue&type=template&id=0221369c&"
import script from "./FolderListSidebar.vue?vue&type=script&lang=js&"
export * from "./FolderListSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports